import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  dashboardLayout: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    background: theme.palette.primary.main,
    overflow: 'hidden',
    '@media (max-width: 1024px)': {
      display: 'block',
      position: 'relative',
    },
    // '@media (max-width: 767px)': {
    //   overflow: 'inherit',
    //   height: '100%',
    // },
  },
  dashLayoutLeft: {
    background: theme.palette.common.white,
    flex: '0 0 auto',
    width: 278,
    overflow: 'hidden overlay',
    boxShadow: theme.shadows[2],
    '@media (max-width: 1220px)': {
      width: 230,
    },
    '@media (max-width: 1024px)': {
      position: 'sticky',
      top: 0,
      height: 70,
      zIndex: 100,
      margin: 0,
      border: 0,
      width: '100%',
      padding: 0,
      background: theme.palette.primary.contrastText,
      boxShadow: theme.shadows[6],
    },
  },
  dashLayoutRight: {
    width: 'calc(100% - 280px)',
    flexGrow: 1,
    position: 'relative',
    overflow: 'auto',
    height: '100vh',
    // border: '1px solid #fff',
    '@media (max-width: 1220px)': {
      width: 'calc(100% - 230px)',
    },
    '@media (max-width: 1024px)': {
      width: '100%',
      margin: 0,
      marginBottom: 0,
      height: 'calc(100vh - 70px)',
    },
    '@media (max-width: 767px)': {
      width: '100%',
      margin: 0,
      border: 0,
      borderRadius: 0,
      height: 'calc(100% - 70px)',
      overflow: 'hidden overlay',
    },
  },
  dashLayoutRightBox: {
    height: '100%',
    overflow: 'auto',
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      backgroundColor: '#1EA59A',
      width: '0.6em',
      visibility: 'hidden',
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      borderRadius: 8,
      backgroundColor: theme.palette.warning.main,
      minHeight: 24,
      border: '1px solid #1EA59A',
      visibility: 'hidden',
    },
    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
      backgroundColor: '#2B2B2B',
    },
    '@media (max-width: 767px)': {
      overflow: 'overlay',
    },
  },
  dashLayoutRightCont: {
    padding: '40px 60px',
    overflow: 'hidden',
    // height: 'calc(100vh - 80px)',
    '@media (max-width: 1024px)': {
      padding: '40px 5% 30px',
    },
    '@media (max-width: 767px)': {
      padding: '20px 5%',
      // height: 'calc(100vh - 30px)',
    },
  },
  dashLayoutRightCont1: {
    padding: '40px 60px',
    // overflow: 'hidden',
    height: 'calc(100% - 80px)',
    '@media (max-width: 1024px)': {
      padding: '40px 5% 30px',
    },
    '@media (max-width: 767px)': {
      padding: '30px 5% 0px',
      height: 'auto',
      // height: 'calc(100vh - 30px)',
    },
  },
}));
